import { EditInventory } from 'components/Protected/Inventory/EditInventory'

function EditInventoryPage() {
  return <EditInventory />
}

export default EditInventoryPage
